import { ParkingFilters } from './parking-filters';
import { ParkingLotId, ParkingLotName } from './parking-lot';
import { ParkingPrice } from './parking-price';
import { ParkingVehicle } from './parking-vehicle';

import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export interface Parking extends Required<ParkingVehicle> {
  Amount: number;
  NuProdQuant: number;
  customer_paid: number;
  doNotBurn: number;
  end_time: string;
  instructions: string;
  item_id: string;
  item_name: string;
  location: ParkingLotName;
  lot: ParkingLotId;
  price: number;
  quantity: number;
  reservation: string;
  start_time: string;
  status: string;
  total: number;
  days: number;
  dayPrice: number;
  type: 'parking';
}

export interface ParkingWithoutVehicle extends Omit<Parking, keyof ParkingVehicle> { }

const computeReservation = () =>
  Math.random()
    .toString(36)
    .replace(/[^a-z]+/g, '')
    .substring(0, 16);

/**
 * Return a date similar like this: 2024-04-24T01:30:00
 */
const computeParkingTime = (date: string, time: string) => {
  const tijuanaTime = dayjs(time).tz('America/Tijuana').format('HH:mm:ss');
  return `${date.split('T')[0]}T${tijuanaTime}`;
}

export const buildParkingWithoutVehicle = (
  { price, lot, days, dayPrice }: ParkingPrice,
  parkingFilters: ParkingFilters,
): ParkingWithoutVehicle => {
  const parkingLot = lot[0];

  return {
    Amount: price,
    NuProdQuant: 1,
    customer_paid: price,
    doNotBurn: 0,
    end_time: computeParkingTime(parkingFilters.exitDate, parkingFilters.exitTime),
    instructions: 'Valid for one use',
    item_id: `Parking ${parkingLot.location_name}`,
    item_name: `Parking ${parkingLot.location_name}`,
    location: parkingLot.location_name,
    lot: parkingLot.id,
    price: price,
    quantity: 1,
    reservation: computeReservation(),
    start_time: computeParkingTime(parkingFilters.entryDate, parkingFilters.entryTime),
    status: 'valid',
    total: price,
    type: 'parking',
    days,
    dayPrice,
  };
};

export const addVehicleToParking = (
  parkingWithoutVehicle: ParkingWithoutVehicle,
  vehicle: ParkingVehicle,
): Parking => ({
  ...parkingWithoutVehicle,
  ...vehicle,
  vehicleDescription: `${vehicle.brand} ${vehicle.model} ${vehicle.year} color ${vehicle.color}`,
});
